import React, { useState } from "react";

// TimeOption component (a time slot during the day)
const TimeOption = (props) => {
    const {
        time,
        prices,
        seats,
        thisTimeIndex,
        isMember,
        isWAResident,
        selectedTime,
        setSelectedTime,
        selectedTimeIndex,
        setSelectedTimeIndex
    } = props;

    let adultPrice, WAAdultPrice;

    if (!isMember) {
        adultPrice = prices.find(price => price.applies_to === 'Adult')?.price ?? 'n/a';
        WAAdultPrice = prices.find(price => price.applies_to === 'WA Adult')?.price ?? 'n/a';
    }

    let soldOutMember = seats.member.available == 0;
    let soldOutGeneral = seats.general.available == 0;

    function handleClick() {
        setSelectedTimeIndex(thisTimeIndex);
        setSelectedTime(time);
    }

    return (
        <>
            <div
                className={`carousel-selector__time ${time == selectedTime ? 'carousel-selector__time--selected' : ''}`}
                onClick={() => handleClick()}
                disabled={(!isMember && soldOutGeneral) || (isMember && soldOutMember)}
            >
                <h6 className="carousel-selector__time-slot">{time.replace(/^0+/, '')}</h6>
                {/*!isMember && <div className="carousel-selector__price">
                    Adults from<br/>
                    <span className="carousel-selector__price-amount">
                        ${isWAResident.isResident && isWAResident.isConfirmed ? WAAdultPrice + ' (WA)' : adultPrice}
                    </span>
                </div>*/}

                {/* guest */}
                {!isMember && !soldOutGeneral && <>
                    <div className="carousel-selector__ticket-meter" data-availability={Math.ceil(((seats.general.available / seats.general.capacity) * 10) / 2)}></div>
                    <div className="carousel-selector__ticket-number">{seats.general.available} ticket{seats.general.available === 1 ? '' : 's'} available</div>
                </>}

                {/* member */}
                {isMember && !soldOutMember && <>
                    <div className="carousel-selector__ticket-meter" data-availability={Math.ceil(((seats.member.available / seats.member.capacity) * 10) / 2)}></div>
                    <div className="carousel-selector__ticket-number">{seats.member.available} ticket{seats.member.available === 1 ? '' : 's'} available</div>
                </>}

                {/* sold out */}
                {((!isMember && soldOutGeneral) || (isMember && soldOutMember)) && <>
                    <div>Sold Out</div>
                </>}
            </div>
        </>
    );
}

export default TimeOption;